import { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";


const Tooltip = ({ nametext,numbertext,bsbtext, currencytext,amounttext,children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const tooltipRef = useRef(null);
  const handleScroll = (indexToRemove) => {
    console.log("I xan scroll");
    setIsVisible(false);
  };
  useEffect(() => {
    if (isVisible) {
      console.log("Dropdown for create opened, adding scroll event listener.");
      window.addEventListener("scroll", handleScroll, { passive: true });
    } else {
      console.log(
        "Dropdown for create closed, removing scroll event listener."
      );
      window.removeEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isVisible]);
  const handleMouseEnter = (event) => {
    setIsVisible(true);
    
    // Get bounding box of target element
    const rect = event.target.getBoundingClientRect();
    setPosition({
      top: rect.top -80, // Adjust based on height
      left: rect.left + rect.width / 2, // Center horizontally
    });
  };
  return (
    <div
      className="relative inline-block"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible 
        &&
        createPortal(
      <div             ref={tooltipRef}
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        transform: "translateX(-50%)",
      }}
      className="fixed px-3 py-1 text-xs text-white bg-white rounded-lg shadow-lg whitespace-nowrap z-[9999]">
      <div className="relative">
        <span className="text-[#888888]">
          Account Name:{" "}
          <span className="text-[#595959]">
            {nametext}
          </span>
        </span>
        <br />
        <span className="text-[#888888]">
          Account Number:{" "}
          <span className="text-[#595959]">
            {numbertext}
          </span>
        </span>
      {bsbtext&&<span>
        <br />
        <span className="text-[#888888]">
          BSB:{" "}
          <span className="text-[#595959]">
            {bsbtext}
          </span>
        </span>
        </span> 
        }  
        <br />
        <span className="text-[#888888]">
          Account Currency:{" "}
          <span className="text-[#595959]">
            {currencytext}
          </span>
        </span>
                <br />

<span className="text-[#888888]">
          Transaction Amount:{" "}
          <span className="text-[#595959]">
            {Number(amounttext).toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </span>
        </span>
        {/* Tail of the tooltip */}
        <div className="absolute -bottom-2 right-20 w-3 h-3 bg-white transform rotate-45"></div>
      </div>
    </div>,
        document.body
    )}
    </div>
  );
};

export default Tooltip;
